<script>
import { defineComponent, computed, h } from 'vue';

export default defineComponent({
    name: 'MvtReorder',

    props: {
        order: {
            type: Array,
            default: () => [],
        },
    },

    setup(props, { slots, attrs }) {
        const orderedChildren = computed(() => {
            const vnodes = slots.default ? slots.default() : [];

            if (!props.order || props.order.length === 0) {
                return vnodes;
            }

            const byKey = new Map();
            const unordered = [];

            for (const vnode of vnodes) {
                const key = vnode.props && vnode.props.orderKey;

                if (key && props.order.includes(key)) {
                    if (!byKey.has(key)) {
                        byKey.set(key, []);
                    }
                    byKey.get(key).push(vnode);
                } else {
                    unordered.push(vnode);
                }
            }

            const result = [];

            // push in configured order
            for (const key of props.order) {
                const bucket = byKey.get(key);
                if (bucket && bucket.length > 0) {
                    for (let i = 0; i < bucket.length; i++) {
                        result.push(bucket[i]);
                    }
                }
            }

            // then everything else
            for (let i = 0; i < unordered.length; i++) {
                result.push(unordered[i]);
            }

            return result;
        });

        return () =>
            h(
                'div',
                attrs,
                orderedChildren.value
            );
    },
});
</script>